import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.contact.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_CONTACT_ASYNC: `${uid}.saveContactAsync`,
    SAVE_CONTACT_SUCCESS: `${uid}.saveContactSuccess`,
    SAVE_CONTACT_FAILURE: `${uid}.saveContactFailure`,
};

export { ActionTypes };
